module.exports = __webpack_public_path__ + "3055674f97ef1b295ba52ee8c457a71a.woff";